import { Toaster } from "react-hot-toast";
import { FaBug } from "react-icons/fa";
import { useState } from "react";

import BugSuggestionForm from "./components/utils/BugSuggestionForm.tsx";
import socket from "./config/socket.io.ts";
import { GoogleOneTap } from "./pages/auth/GoogleOneTap.tsx";
import ScrollToTop from "./components/utils/ScrollToTop.tsx";
import SubdomainResolver from "./context/SubdomainResolver.tsx";

export default function App(){
  const [bugModalOpen, setBugModalOpen] = useState(false);

  socket.emit("appstart", {
    message: "App started!",
    time: new Date().toISOString(),
  });

return (
    <>
      {/* Floating bug report button */}
      <button
        onClick={() => setBugModalOpen(!bugModalOpen)}
        title="Report bug or send suggestion"
        className="fixed right-4 bottom-6 z-50 animate-bounce cursor-pointer rounded-full border-2 border-amber-600 bg-amber-500 p-3 shadow-lg transition-colors hover:bg-amber-600"
      >
        <FaBug className="text-xl text-white" />
      </button>

      {bugModalOpen && (
        <div
          className="fixed inset-0 z-50 flex w-full items-center justify-center bg-black/50"
          onClick={() => setBugModalOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="overflow-y-scroll"
          >
            <BugSuggestionForm />
          </div>
        </div>
      )}
      <SubdomainResolver />
      <ScrollToTop />
      <GoogleOneTap />

      <Toaster position="top-right" />
    </>
  );
};
